import type { IHttpClient } from "@/core/interfaces";
import { extractItems, isRecord } from "@/core/utils";
import { Registry } from "@/shared/infra/dependency-injection/registry";

export const PERMISSOES_PATHS = {
  ME: "/api/usuarios/me/permissoes",
} as const;

function getHttpClient(): IHttpClient {
  return Registry.getInstance().inject<IHttpClient>("HttpClient");
}

/**
 * Lê os códigos de permissão do usuário logado. Contrato do bff:
 * `{ success, data: { permissoes: string[] } }`. Entradas inválidas são descartadas.
 */
export async function listMinhasPermissoes(signal?: AbortSignal): Promise<string[]> {
  const response = await getHttpClient().get<unknown>(PERMISSOES_PATHS.ME, { signal });

  const body = isRecord(response.data) ? response.data : {};
  const data = isRecord(body.data) ? body.data : body;

  const codes = extractItems(data.permissoes)
    .filter((item): item is string => typeof item === "string")
    .map((item) => item.trim())
    .filter((item) => item.length > 0);

  return [...new Set(codes)];
}
